import { render, staticRenderFns } from "./ManageGeneral.vue?vue&type=template&id=c0ab726c&scoped=true&"
import script from "./ManageGeneral.vue?vue&type=script&lang=js&"
export * from "./ManageGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ab726c",
  null
  
)

export default component.exports